<template>
  <button
    v-bind="$attrs"
    :class="['btn', className]"
    v-on="$listeners"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  props: ['className', 'text'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseButton.vue